import React, { ReactNode } from 'react';

import styles from './styles.module.css';
import GridContainer from '../GridContainer';

interface CardsViewProps {
  children: ReactNode;
  gap?: string;
  minItemWidth?: string;
  className?: string;
}

const CardsView: React.FC<CardsViewProps> = ({
  children,
  gap = '20px',
  minItemWidth = '350px',
  className = 'global-view-container'
}) => {
  return (
    <div className={styles.cardsContainer}>
      <GridContainer
        gap={gap}
        minItemWidth={minItemWidth}
        className={className}
      >
        {children}
      </GridContainer>
    </div>
  );
};

export default CardsView;
